window.$ = require('jquery');
window.jQuery = require('jquery');
window._ = require('lodash');

require('bootstrap');
require('admin-lte');
require('select2');

require('parsleyjs');
require('parsleyjs/dist/i18n/es');
require('parsleyjs/dist/i18n/en');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// window.routes = require('./modules/routes');
window.translations = require('./modules/translations');
window.messages = require('./modules/messages');
window.blockui = require('./modules/blockui');
window.forms = require('./modules/forms');
window.datatables = require('./modules/datatables');

window.app = {};
window.app.profile = require('./app/profile');

window.app.admin = {};
window.app.admin.users = require('./app/admin/users');
window.app.admin.groups = require('./app/admin/groups');
window.app.admin.logs = require('./app/admin/logs');

window.app.microsites = require('./app/microsites/microsites');
window.app.microsites.variables = require('./app/microsites/variables');
window.app.microsites.redirections = require('./app/microsites/redirections');
window.app.microsites.errors404 = require('./app/microsites/errors404');
window.app.microsites.menus = require('./app/microsites/menus');
window.app.microsites.categories = require('./app/microsites/categories');
window.app.microsites.tags = require('./app/microsites/tags');
window.app.microsites.contents = require('./app/microsites/contents');
window.app.microsites.forms = require('./app/microsites/forms');
window.app.microsites.calendars = require('./app/microsites/calendars');
window.app.microsites.tokens = require('./app/microsites/tokens');
window.app.microsites.comments = require('./app/microsites/comments');
window.app.microsites.queries = require('./app/microsites/queries');

// esto lo último porque desencadena los eventos de inicialización de vistas
window.callbacks = require('./modules/callbacks');